import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const SidebarOptions = (props) => { 
    return (
        <div className="sidebar-options">
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarOptions);
